package com.exura.features.legacyplans.data.repository

import com.exura.features.firebase.domain.repository.UserPrefixedRepository
import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.legacyplans.LegacyPlansCollections
import com.exura.features.legacyplans.domain.model.DetailedPlan
import com.exura.features.legacyplans.domain.repository.BaseDetailedPlanRepository
import com.exura.features.legacyplans.domain.repository.DetailedPlanRepository

class DetailedPlanRepositoryImpl(
    baseRepository: BaseDetailedPlanRepository,
    getUserDataPrefixUseCase: GetUserDataPrefixUseCase,
) : DetailedPlanRepository, UserPrefixedRepository<DetailedPlan, DetailedPlan>(
    baseRepository = baseRepository,
    getDataPrefix = suspend { getUserDataPrefixUseCase() },
    collectionName = LegacyPlansCollections.PROVIDER_LEGACY_DETAILED_PLANS,
)
